import 'hammerjs';
import noop from 'lodash/noop';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { MapModule } from '../../map/module';
import { DispatchTrackingComponent } from './dispatch-tracking.component';
import { DashboardSettings } from '../../services/dashboard-settings';
import { DispatchTrackingService } from './dispatch-tracking.service';
import { ServerApi } from '../../services/server-api';
import { GroupsFilter } from '../../services/groups-filter';
import { SessionStorage } from '../../services/session-storage';
import { CustomHttpParamCodec } from '../../services/custom-http-param-codec';
import { HammerConfig } from './hammer.config';
import { CommonComponentsModule } from '../../common-components/module';
import { DispatchCompletedComponent } from './dispatch-completed/dispatch-completed.component';
import { DispatchNotFoundComponent } from './dispatch-not-found/dispatch-not-found-component';
import { ShareTrackingModalModule } from '../../modals/share-tracking-modal/module';
import { CommonPipesModule } from '../../pipes/module';
import { DispatchSidepanStepModule } from '../../misc/dispatch-sidepan-step/dispatch-step.module';
import { DurationPipe } from '../../pipes/duration';

const COMPONENTS = [
  DispatchTrackingComponent,
  DispatchCompletedComponent,
  DispatchNotFoundComponent,
];

@NgModule({
  declarations: COMPONENTS,
  imports: [
    HttpClientModule,
    CommonModule,
    MapModule,
    CommonComponentsModule,
    ShareTrackingModalModule,
    CommonPipesModule,
    DispatchSidepanStepModule,
    RouterModule.forChild([
      { path: '', component: DispatchTrackingComponent },
    ]),
  ],
  providers: [
    { provide: DashboardSettings, useValue: noop },
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: HammerConfig,
    },
    DispatchTrackingService,
    ServerApi,
    GroupsFilter,
    SessionStorage,
    CustomHttpParamCodec,
    DurationPipe,
  ],
})
export class DispatchTrackingModule { }
